const ANIMATION_DURATION = 0.3;


















export { ANIMATION_DURATION };